import Landing from "@/components/Screen/Landing";
import Home from "@/components/Screen/Home";
import Metrology from "@/components/Screen/Metrology";
import Inspection from "@/components/Screen/Inspection";
import Analysis from "@/components/Screen/Analysis";
import Applications from "@/components/Screen/Applications";
import XraySeries from "@/components/Screen/XraySeries";
import WhyXray from "@/components/Screen/WhyXray";
import Systems from "./components/Screen/XraySeries/Systems";
import Software from "./components/Screen/XraySeries/Software";

export default [

	{
		path: '/',
		name: 'landing',
		component: Landing,
		iconPosition: {
			en: -15,
			de: -15,
			zh: -15
		},
		breadcrumb: {
			title: '',
			level: 0
		},
		backPath: '/'
	},
	{
		path: '/home',
		name: 'home',
		component: Home,
		iconPosition: {
			en: 63.815,
			de: 91.17,
			zh: 54.415
		},
		backPath: '/'
	},
	{
		path: '/metrology',
		name: 'metrology',
		component: Metrology,
		iconPosition: {
			en: 232.42,
			de: 280.88,
			zh: 177.415
		},
		backPath: '/home'
	},
	{
		path: '/inspection',
		name: 'inspection',
		component: Inspection,
		iconPosition: {
			en: 421.98,
			de: 474.495,
			zh: 300.415
		},
		backPath: '/home'
	},
	{
		path: '/analysis',
		name: 'analysis',
		component: Analysis,
		iconPosition: {
			en: 595.015,
			de: 643.48,
			zh: 423.415
		},
		backPath: '/home'
	},
	{
		path: '/applications',
		name: 'applications',
		component: Applications,
		iconPosition: {
			en: 783.35,
			de: 840.195,
			zh: 546.415
		},
		backPath: '/home'
	},
	{
		path: '/x-ray_series',
		name: 'x-ray_series',
		component: XraySeries,
		iconPosition: {
			en: 1019.42,
			de: 1076.005,
			zh: 719.365
		},
		backPath: '/home'
	},
	{
		path: '/x-ray_series/systems',
		name: 'x-ray_series-systems',
		component: Systems,
		iconPosition: {
			en: 1019.42,
			de: 1076.005,
			zh: 719.365
		},
		backPath: '/x-ray_series'
	},
	{
		path: '/x-ray_series/software',
		name: 'x-ray_series-software',
		component: Software,
		iconPosition: {
			en: 1019.42,
			de: 1076.005,
			zh: 719.365
		},
		backPath: '/x-ray_series'
	},
	{
		path: '/why_x-ray',
		name: 'why_x-ray',
		component: WhyXray,
		iconPosition: {
			en: 1222.59,
			de: 1318.505,
			zh: 978.32
		},
		backPath: '/home'
	}

];
